import styled from 'styled-components'
import { Radio } from 'antd'

const AntRadioStyled = styled(Radio)`
  &&& {
    :hover {
      .ant-radio {
        .ant-radio-inner {
          border-color: ${props => props.theme.colors.color1.bg};
        }
        .ant-radio-inner:after {
          background-color: ${props => props.theme.colors.color1.bg};
        }
      }
    }
    .ant-radio-checked {
      .ant-radio-inner {
        border-color: ${props => props.theme.colors.color1.bg};
      }
      .ant-radio-inner:after {
        background-color: ${props => props.theme.colors.color1.bg};
      }
    }
  }
`

export default AntRadioStyled
